<app-auto-complete-list-group
  (selectChange)="onSelectChangeStudent($event)"
  (searchChange)="onSearchChangeStudent($event)"
  [itemsData]="students"
  [selectedItemsData]="form?.get(this.controlName)?.value"
  [shouldShowDefaultMessage]="shouldShowDefaultMessage"
  [defaultMessageContent]="defaultMessageContent"
  [shouldShowSelectedItemsList]="shouldShowSelectedItemsList"
  [shouldBeAbleToEditListGroupItem]="shouldBeAbleToEditListGroupItem"
  [removeSelectedItem]="removeSelectedItem"
  [inputId]="inputId"
  [inputTitle]="inputTitle | translate"
  [placeholder]="placeholder | translate"
  [rosterStudents]="form?.controls?.rosterStudents?.value"
></app-auto-complete-list-group>
